import { getSecurityAlertContent } from '../../../changePwd/src/form/getSecurityAlertContent.js';
import { LONGMAX_PWD, LONGMIN_PWD } from '../../../shared/validators/isValidPassword.js';
import { showFormAlert } from '../view/showFormAlert.js';

/* EXAMPLE stepData
  {
      "strongPwd": "0",
      "numChanges": "3",
      "pass": "otp01234",
      "longitudMinima": "8",
      "expiredDays": "30"
  }
*/
export default {
  events: {
    visible: (eWizard, stepData) => {
      // fix:
      stepData.strongPwd = parseInt(stepData.strongPwd);
      stepData.longitudMinima = parseInt(stepData.longitudMinima) || LONGMIN_PWD;

      const eAlert = eWizard.querySelector('#alertSecurity');
      if (eAlert) {
        eAlert.innerHTML = getSecurityAlertContent({
          // isRenewPwd true forzado: No queremos mostrar el texto distinta a la anteror porque seguramente no la conozca el usuario
          isRenewPwd: true,
          strongPassword: stepData.strongPwd,
          longMinPwd: stepData.longitudMinima,
          longMaxPwd: LONGMAX_PWD,
        });
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const pass = eWizard.querySelector('#pass')?.value;
      const passConfirm = eWizard.querySelector('#passConfirm')?.value;

      if (!pass || !passConfirm) {
        showFormAlert();
      } else if (pass !== passConfirm || pass.length < stepData.longitudMinima) {
        showFormAlert('enrollment.bmemail.label.passError2');
      } else if (pass === stepData.pass) {
        showFormAlert('login.error_new_password');
      } else {
        stepData.pass = pass;
        resolve(stepData);
        return; // OK
      }

      reject(); // KO
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.bmpassword.title')}">
    <ewc-alert type="flat" label="${edicom.locale.translate('enrollment.bmpassword.title')}">
      <span>${edicom.locale.translate('enrollment.bmpassword.intro')}</span>
    </ewc-alert>
    <ewc-form-layout>
      <ewc-password id="pass" label="${edicom.locale.translate(
        'enrollment.bmpassword.label.password'
      )}" minlength="${LONGMIN_PWD}" maxlength="${LONGMAX_PWD}" required cols="4"></ewc-password>
      <ewc-password id="passConfirm" label="${edicom.locale.translate(
        'enrollment.bmpassword.label.passConfirm'
      )}" minlength="${LONGMIN_PWD}" maxlength="${LONGMAX_PWD}" required cols="4"></ewc-password>
      <ewc-password-bar target="#pass" cols="8"></ewc-password-bar>
      <ewc-alert id="alertSecurity" type="info" cols="8"></ewc-alert>
    </ewc-form-layout>
  </template>`,
};
